import { tickerItems } from "@/mocks/news";

export default function LiveTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section aria-label="实时快讯滚动条" className="w-full border-y border-primary-700/40 bg-primary-500 text-background-50">
      <div className="mx-auto flex w-full max-w-[1400px] items-center gap-3 px-0 md:px-6">
        <span className="flex shrink-0 items-center gap-2 px-4 py-3 text-xs font-semibold tracking-widest md:ml-0 md:rounded-l-md md:px-3">
          <span className="live-dot h-2 w-2 rounded-full bg-accent-300"></span>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {loopItems.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-3 px-5 text-sm text-background-50/95">
                <i className="ri-flashlight-fill text-accent-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}